import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCoreStoresResponse, transformCoreStoresLanguages, transformCoreStoresStore } from './transformers.js';
import defaultClient from 'axios';

const getCoreStores = async ({ client , controller , store  } = {})=>await client.get(`/V1/core/stores/${store}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCoreStoresResponse)
        ]
    });
getCoreStores.key = 'getCoreStores';
const getCoreStoresLanguages = async ({ client , controller , store  } = {})=>await client.get(`/V1/core/stores/languages/${store}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCoreStoresLanguages)
        ]
    });
getCoreStoresLanguages.key = 'getCoreStoresLanguages';
const getCoreStoresStore = async ({ client , controller , countryCode  } = {})=>await client.get(`/V1/core/stores/store/${countryCode}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCoreStoresStore)
        ]
    });
getCoreStoresStore.key = 'getCoreStoresStore';

export { getCoreStores, getCoreStoresLanguages, getCoreStoresStore };
